import { render, staticRenderFns } from "./sidewidth.vue?vue&type=template&id=ee62c6d4&scoped=true"
import script from "./sidewidth.vue?vue&type=script&lang=js"
export * from "./sidewidth.vue?vue&type=script&lang=js"
import style0 from "./sidewidth.vue?vue&type=style&index=0&id=ee62c6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee62c6d4",
  null
  
)

export default component.exports